export const defaultSentMessageAnchorStyles = {
  color: "blue"
};